const state = {
  params: {
    page: 1,
    per_page: 30,
    q: {
      ticketname: "",
      user_keyword: "",
      status: "",
      pay_status: "",
      start_time: "",
      end_time: "",
      ticket_sn: "",
      shop_name: "",
      activity_name: "",
      ticket_created_start_time: "",
      ticket_created_end_time: "",
      user_id: "",
    },
  },
  downData: [],
  screenItems: [],
};

const mutations = {
  reviseTicketParams(state, val) {
    state.params = val;
  },
  changeTicketDownList(state, val) {
    state.downData = val;
  },
  changeTicketItems(state, val) {
    state.screenItems = val;
  },
};

export default {
  state,
  mutations,
};
